import React, { useEffect } from "react";

function Page(props) {
  console.log("[PAGE] Page render");
  useEffect(() => {
    console.log("[PAGE] MOUNT");
    return () => console.log("[PAGE] UNMOUNT");
  }, []);
  return (
    <>
      <div className="aspect-ratio">
        <div className="content">{props.children}</div>
      </div>
    </>
  );
}

export default Page;
